<script lang="ts">
  import SectionTitle from "@kontextwerk/web-sdk/ui/typography/SectionTitle.svelte"
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import ToggleCTA from "@kontextwerk/web-sdk/ui/actions/ToggleCTA.svelte"
  import Icon from "@kontextwerk/web-sdk/ui/primitives/Icon.svelte"
  import { mdiPlus } from "@mdi/js"
  import { openOverlay } from "@kontextwerk/web-sdk/core/overlay/globalStores"
  import type { OrganizationFrame } from "@kontextwerk/control-web-client"
  import CustomerCreateOverlay from "../../../../../../_shared/_modules/customer-create-overlay"
  import { customerImportLocked } from "../../../../../../../../../_shared/_logic/customer-import-status"
  import type { FilterDisplayMode } from "../../_shared/_logic/customers-table-contract"

  type Props = {
    organization: OrganizationFrame | null
    onCustomerCreated: (customer: Customer) => void
    canEdit?: boolean
    title?: string
    filterMode?: FilterDisplayMode | null
    onFilterModeChange?: ((value: FilterDisplayMode) => void) | null
  }

  let {
    organization,
    onCustomerCreated,
    canEdit = true,
    title = "Ansprechpartner",
    filterMode = null,
    onFilterModeChange = null,
  }: Props = $props()

  const showFilterModeToggle = $derived(Boolean(filterMode && onFilterModeChange))
  const importLocked = $derived(Boolean($customerImportLocked))
  const lockedTooltip =
    "Während der Kehrbezirksimport verarbeitet wird, sind Änderungen am Kehrbezirk gesperrt."
  const filterModeOptions = [
    { value: "compact", label: "Kompakt" },
    { value: "detailed", label: "Ausführlich" },
  ]

  const openCreateOverlay = () => {
    if (!organization?.id || importLocked) return

    openOverlay({
      title: "Neuen Ansprechpartner anlegen",
      content: CustomerCreateOverlay,
      closeOnParentOpen: true,
      properties: {
        organizationId: organization.id,
        onCreated: (created: Customer) => {
          onCustomerCreated(created)
        },
      },
    })
  }
</script>

<SectionTitle
  {title}
  brightBackground={true}
  styleOuter="margin-bottom: 1.2rem;"
  helpModalTextId="customerRegistry"
>
  {#snippet buttonSnippet()}
    {#if showFilterModeToggle}
      <ToggleCTA
        options={filterModeOptions}
        value={filterMode ?? "compact"}
        darkMode={false}
        onChange={(value) => {
          const nextValue = `${value ?? filterMode ?? "compact"}`.toLowerCase()
          onFilterModeChange?.(nextValue === "detailed" ? "detailed" : "compact")
        }}
      />
    {/if}
    <div class="customers-actions">
      {#if canEdit}
        <CTA
          type="primaryButton"
          content=""
          tooltipContent={importLocked ? lockedTooltip : "Neuen Ansprechpartner anlegen"}
          onClick={openCreateOverlay}
          disabled={importLocked}
        >
          {#snippet iconSnippet()}
            <Icon path={mdiPlus} />
          {/snippet}
        </CTA>
      {/if}
    </div>
  {/snippet}
</SectionTitle>

<style lang="less">
  .customers-actions {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
</style>
